// This file is automatically generated.
// Do not edit this file manually, use the script createLocales.js!

/* eslint-disable quotes */
/* eslint-disable indent */

export default {
  "__vendor__": "resol",
  "devise": {
    "failure": {
      "bad_request": "The data transmitted have been faulty. Please try again.",
      "already_registered": "This e-mail address has already been registered. An activation e-mail has been sent for activating your account. Please check your inbox and activate your account.",
      "timeout": "Your session has expired, please sign in again to continue.",
      "forbidden": "Forbidden",
      "invalid": "Invalid email or password.",
      "username": {
        "already_in_use": "This user name is already in use!"
      },
      "email": {
        "already_in_use": "This e-mail address has already been registered!"
      },
      "already_activated": "If your e-mail address exists in our database, you will receive an e-mail with instructions about how to reset your password in a few minutes."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Confirmation instructions"
      },
      "reset_password_instructions": {
        "subject": "Reset password instructions"
      }
    },
    "confirmations": {
      "send_instructions": "You will receive an email with instructions about how to confirm your account in a few minutes.",
      "send_instructions_paranoid": "If you have signed up with VBus.net, you will receive an e-mail in a few minutes, by means of which you can confirm your registration. Please check your e-mail inbox."
    },
    "passwords": {
      "updated_not_active": "Your password was changed successfully.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes."
    },
    "registrations": {
      "destroyed": "Bye! Your account was successfully cancelled. We hope to see you again soon."
    }
  },
  "general": {
    "welcome": "Welcome",
    "yourProAccount": "Your VBus.net PRO access",
    "hello": "Hello",
    "greetings": "Best regards",
    "vbusnetTeam": "Your VBus.net team",
    "errorInvalidCharacters": "Invalid characters",
    "emailUnsubscribed": "Your e-mail address has been successfully removed from the mailing list.",
    "emailAlreadyUnsubscribed": "Your e-mail address has already been removed from the mailing list.",
    "newDevice": "New device",
    "isFriend": "Share",
    "backup": {
      "error": {
        "file": "Backup file invalid or corrupt!",
        "fileMatchSystem": "Backup file does not suit the system selected"
      },
      "choose": {
        "file": "Select backup file…"
      },
      "restore": "Restore backup",
      "successful": "Your data have been succesfully restored.",
      "name": "Backup",
      "create": "Create backup",
      "text1": "Here you will find an overview of your data. Select the desired points to be saved. If you select a live system, diagram or download, all corresponding filters and images will be saved, too.",
      "file": "Backup file",
      "text2": "In the following, all backup data are listed. You can restore all data or data selected. If you select a live system, diagram or download, all corresponding filters and images will be restored, too.",
      "fileType": "The file must be a valid VBus.net backup file!",
      "text3": "Your live data have changed since the backup has been created! This can happen if new devices have been connected or existent devices have been removed or reconnected. Please note that after restoring, the filter attribution may be incorrect.",
      "visualization": "Visualization data backup"
    },
    "days": "Days",
    "entryNotFound": "No entry has been found.",
    "allValues": "All values",
    "unknown": "Unknown",
    "from": "From",
    "to": "To",
    "customRange": "Custom period of time",
    "name": "Name",
    "unit": "Unit",
    "color": "Color",
    "format": "Format",
    "errorTryAgain": "An error has occured! Please try again later...",
    "interestedInProducts": "Thank you for your interest in our products.",
    "ok": "OK",
    "currentAccount": "Current access",
    "newInvalidDate": "New expiration date",
    "KontaktformularKenntnis": "I have read and understood the __PRIVACY_POLICY__. I agree that my information and data are electronically collected and stored for answering my enquiry.",
    "interval": "Interval",
    "minute": "Minute",
    "minutes": "minutes",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "displayValue": "Display value",
    "conversions": "Conversions",
    "add": "add",
    "displayUnit": "Display unit",
    "none": "None",
    "close": "Close",
    "apply": "Apply",
    "note": "Note",
    "deleteIrrevocably": "The data will be irrevocably deleted!",
    "delete": "Delete",
    "errors": "Errors",
    "noErrors": "No errors",
    "error": "Error",
    "deleted": "Deleted!",
    "entryDeleted": "The entry has been deleted.",
    "save": "Save",
    "edit": "Edit",
    "status": "Status",
    "cancel": "Cancel",
    "weiter": "Continue",
    "yesDelete": "Yes, delete.",
    "no": "No",
    "configurationDeleted": "Configuration has been deleted.",
    "selectAll": "Select all",
    "unselectAll": "Unselect all",
    "download": "Download",
    "prefix": "Prefix",
    "subscription": "Access",
    "information": "Information",
    "passwordCurrent": "Current password",
    "languageForEmail": "Language (e-mails)",
    "defaultUnits": "Standard units",
    "dateFormat": "Date format",
    "myPersonalSettings": "My personal data",
    "changeYourPassword": "Change your password",
    "login": "Login",
    "newPassword": "New Password",
    "passwordLength": "must be at least 6 characters",
    "passwordConfirmNewPassword": "Confirm new password",
    "forgotYourPassword": "Forgot your password?",
    "passwordDifferent": "The two passwords do not match!",
    "password": "Password",
    "nameResolRegler": "RESOL controller",
    "pleaseChoose": "Please choose",
    "invalidCharacters": "Invalid characters",
    "chooseLanguage": "Choose language",
    "langGerman": "German",
    "langEnglish": "English",
    "langFrench": "French",
    "langItalian": "Italian",
    "langSpanish": "Spanish",
    "langSuomi": "Finnish",
    "showDiagram": "Show diagram",
    "diagramTitle": "Diagram title",
    "publicLink": "Public link",
    "loadingData": "Fetching data, please wait",
    "saving": "Saving",
    "yourLiveData": "Your live data",
    "warningNoLivedata": "No live data available!",
    "noResults": "Your selection does not give any results!",
    "removeAll": "Remove all",
    "undo": "Undo",
    "originalNamesValues": "Original name & values",
    "conversionAvailable": "Conversion available",
    "maxAllowedFilterValues": "The filter has more values than allowed!  A demo Datalogger may contain 10 filter values at most. When saving, the first 10 values will be stored. ",
    "filterDeleted": "The filter has been deleted.",
    "showCustomImages": "Custom images",
    "imageDeleted": "The image has been deleted.",
    "system": "System",
    "autoscaleDescription": "Set dimensions of the live system to the maximum display resolution.",
    "lastSent": "Last sent",
    "on": "on",
    "language": "Language",
    "active": "active",
    "inactive": "inactive",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "settings": "General settings",
    "online": "Online",
    "offline": "Offline",
    "confirmed": "confirmed",
    "notConfirmed": "not confirmed",
    "demo": "Demo",
    "accessDatalogger": "The access to VBus.net can be found in the web interface of your Datalogger!",
    "loginDatalogger": "Please log in to the web interface of your Datalogger and activate the access under:",
    "settingsDatalogger": "Device Config / Remote access / Remote Acces over Internet",
    "timezone": "Timezone",
    "location": "Location",
    "geodata": "Coordinates",
    "search": "Search",
    "change": "Change",
    "advancedSettings": "Advanced settings",
    "visuaEnablingVbusnet": "VBus.net regularly connects to your Datalogger or communication module, in order to load current values. This uses the data volume and  transfer rate of your Internet access.If you wish to avoid this, you can deactivate the data traffic here. Please note that new data will then not be retrieved from VBus.net and historical data will not be synchronised later on by VBus.net.",
    "userComments": "User comments",
    "adminComments": "Admin comments",
    "accessToken": "Access token",
    "claimDevice": "Add new device",
    "yes": "Yes",
    "firmware": "Firmware ",
    "serial": "Serial number",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "userComment": "User comment",
    "defaultSettings": "Basic settings",
    "controller": "Controller",
    "interface": "Interface",
    "technicalData": "Technical data",
    "privatePerson": "Private person",
    "topic": "Topic",
    "yourName": "Your name",
    "addNoticeSing": "Note",
    "sendAdditionalInformation": "Send additional information for easier support",
    "Einwilligung": "Data protection consent",
    "KontaktformularHinweis": "You can revoke your consent for the future at any time via e-mail to vbus.net@resol.com",
    "send": "Send",
    "feedbackText": "General feedback",
    "improvement": {
      "proposal": "Improvement proposal"
    },
    "nameTechnicalSupport": "Technical support",
    "question": "Question",
    "hervorragend": "excellent",
    "gut": "good",
    "neutral": "neutral",
    "ausreichend": "sufficient",
    "unzureichend": "insufficient",
    "kinderleicht": "very easy",
    "intuitiv": "intuitive",
    "kompliziert": "complicated",
    "nichtbedienbar": "not operable",
    "unverzichtbar": "indispensable",
    "sehrhilfreich": "very useful",
    "teilweisenuetzlich": "partly useful",
    "unbrauchbar": "useless",
    "sendResetPasswordInstructions": "Send me reset password instructions",
    "nameTechnicalSupportTime": "Mo. - Fr. 8:00 a.m. - 4:30 p.m. ",
    "feedbackName": "Feedback",
    "feedback": "Feedback form",
    "ImpressumAngaben": "Information according to § 5 of the German Telemedia Act (TMG):",
    "Streitschlichtung": "Mediation",
    "StreitschlichtungText": "We are neither willing nor obliged to take part in a dispute resolution procedure in front of a consumer conciliation body. ",
    "StreitschlichtungAllgemein": "General consumer conciliation body:",
    "nameDataloggerKomm": "DL2/DL3 Datalogger or KM2 Communication module",
    "nameRouter": "Router",
    "Versionsvergleich": "BASIC versus PRO",
    "year": "Year",
    "passwordConfirmation": "Password confirmation",
    "Pflichtfelder": "Fiels marked with * have to be filled in.",
    "resendConfirmationInstuctions": "Please send confirmation e-mail again",
    "back": "Back",
    "years": "Years",
    "basicLiveSystemText": "With the live system editor you can easily display system data selected in a system scheme. You can set the position of the data by simply dragging and dropping the element to the image and add symbols such as stores and valves. The data will be automatically refreshed every 5 minutes without having to reload the page.",
    "basicConnectionText": "VBus.net allows easy and secure access to your system, without any software installation or network knowledge.",
    "freeBasicFunctions": "Basic functions free of charge",
    "basicLiveDataText": "The live data of your system can be displayed in a table – this will give you all current measurement values at a glance.",
    "basicDiagrammeText": "Data stored can be displayed in the form of diagrams.",
    "GeplanteDownloadsText": "Receive your system data stored regularly and automatically via e-mail. Select periods of time and define e.g. further recipients.",
    "ReporteText": "Receive freely configurable reports on the status of the solar system via e-mail. ",
    "GeraetTeilenText": "Share your device with other VBus.net users  ̶  for example, with your installer or energy consultant for information and maintenance purposes.",
    "SystemEditorText": "Use further editing functions to design your live system and add your own component pictures and system graphics.",
    "SicherungText": "VBus.net visualization settings can be saved and restored with just a few clicks.",
    "FehlerprotokollText": "This function gives an overview of errors occured in your system and enables easy and quick troubleshooting.",
    "BenachrichtigungenText": "With this function you can send freely definable e-mail notifications to recipients of your choice, e.g. in the case of error messages.",
    "ParametrisierenText1": "Parameterize your controller from a distance by means of your internet browser. Save configurations directly in VBus.net and transfer them to your controller.",
    "basicText1": "Try VBus.net – the basic version is free of charge and a demo Datalogger will be available right after signing up. Display data in a live system or visualize data stored in a diagram.",
    "basicConnection": "Secure access to your system",
    "basicLiveSystem": "Live systems",
    "basicLiveData": "Show live data",
    "basicDiagramme": "Diagrams",
    "proFunctions": "PRO functions at a glance",
    "logout": "Logout",
    "Funktionsbeschreibung": "Description of functions",
    "kommunikationsmodulKM2": "KM2 Communication module",
    "dataloggerDL2": "DL2 Datalogger",
    "dataloggerDL3": "DL3 Datalogger",
    "Informations": "Information",
    "tools": "Tools",
    "rechtliches": "Legal Matters",
    "products": "Products",
    "preferences": "Settings",
    "menutype": "Quick navigation",
    "Visualisieren": "Visualization",
    "Ueberwachen": "Monitoring",
    "vbusnetRequirements": "Requirements for VBus.net",
    "vbusnetRequirementsText": "For using VBus.net, your RESOL controller with VBus® data interface has to be connected to the internet via a Datalogger (DL2/DL3) or communication module (KM2). Tedious software installation is not required.",
    "VisualisierenText1": "With the VBus.net visualization options, you can always keep an eye on your solar system.",
    "VisualisierenText2": "Visualize your data in a clear system graphic or create diagrams to display your system data in the course of a day, week or month.",
    "UeberwachenText1": "Monitor your system by means of automatic reports and notifications.",
    "UeberwachenText2": "Receive information on the status of your solar system regularly via e-mail. This will keep you up-to-date and help you react, if a problem occurs. Recognize problems at an early stage ̶  set up reports and send them to your installer for fault analysis.",
    "ParametrisierenText2": "The following solar and system controllers are supported: ",
    "proAccountRequired": "A PRO access ir required!",
    "inviteFriend": "Share device",
    "Parametrisieren": "Parameterization",
    "indexPortal": "The portal for your solar and heating system",
    "schnittstellenadapter": "The VBus®/LAN interface adapter is not compatible with VBus.net!",
    "km2": {
      "title": "Economical solution for remote controller access",
      "text": "The KM2 Communication module is the ideal interface between a solar or heating controller and the Internet. Due to the easy and secure connection to the VBus.net Internet portal, system data can be visualised and for example reports on system status via e-mail made available. With the RESOL RPT Parameterisation Tool the controller can be parameterised over the Internet."
    },
    "dl2": {
      "title": "DL2 Datalogger – Remote access to the controller and integrated data logging",
      "text": "The DL2 Datalogger is the interface between a RESOL controller and the Internet and additionally permits logging of system data. The DL2 enables the access to the system data via www.VBus.net."
    },
    "dl3": {
      "title": "DL3 Datalogger – Data logging with an extended range of functions",
      "text": "The DL3 Datalogger is used for logging data of up to 6 RESOL controllers and permits the visualisation via www.VBus.net and the parameterisation via RPT. Get a comprehensive overview of all controllers connected with the large full graphic display, all important settings are directly adjustable on the DL3. The integrated sensor and impulse inputs can measure and log temperatures – even without a controller. The DL3 is furthermore equipped with a BACnet functionality for BACnet conform transmission of data and can thus be used in a building management system."
    },
    "profitPro": "Benefit from all VBus.net functions and order your PRO access.",
    "Funktionsvergleich": "Function comparison",
    "danke": "RESOL says Thank You",
    "team": "Your RESOL team",
    "errorRequired": "__Feld__ is required!",
    "errorInvalid": "__Feld__ is incorrect!",
    "errorNotEqual": "__Feld__ is wrong!",
    "collapse": {
      "all": "Collapse all"
    },
    "expand": {
      "all": "Expand all"
    },
    "help": "Help",
    "loading": "Loading",
    "data": "Data",
    "notice": "Notice",
    "quickDiagram": "Quick diagram",
    "quickDownload": "Quick download",
    "saved": "Saved",
    "unknow": "Unknown",
    "warning": "Attention",
    "upload": "Upload",
    "uploadCustomImage": "Upload custom image",
    "version": "Version",
    "device": "Device",
    "own": {
      "name": "Custom name"
    },
    "getFullVersion": "Get full version",
    "limitations": "Limitations",
    "filter": "Required",
    "addNote": "Additional note",
    "contactAdr": "Contact address",
    "loggedInAs": {
      "prefix": "Logged in as",
      "suffix": "Not you?"
    },
    "actions": "Actions",
    "tip": "Tip",
    "info": "Info",
    "link": "Link",
    "register": "Sign up",
    "or": "or",
    "and": "and",
    "rememberMe": "Remember me",
    "changeMyPassword": "Change my password",
    "wrongEmailOrPassword": "Invalid e-mail or password.",
    "newOwnership": "New device",
    "alert": "Alert",
    "update": "Update",
    "comments": "Comments",
    "videos": "Videos",
    "downloads": "Downloads",
    "dokumente": "Documents",
    "datenblatt": "Data sheet",
    "montageanleitung": "Installation manual",
    "filtern": "filter",
    "type": "Type",
    "until": "until",
    "datapoint": "Data point",
    "seconds": "seconds",
    "hours": "hours",
    "position": "Position",
    "move": "move",
    "billingAdr": "Invoice address",
    "billingAdrAdd": "(if different from the contact address)",
    "terminateFriend": "Withdraw access to device",
    "myFriends": "My shared devices",
    "custom": "user-defined",
    "continuous": "continuously (24 h/d)",
    "immediately": "immediately ",
    "notificationPeriod": "Notification period ",
    "monitoringPeriod": "Monitoring period",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "abbreviation": {
      "example": "e. g."
    },
    "price": "Price",
    "functions": "Functions",
    "required": "Required",
    "errorReport": "Error report",
    "permanent": "unlimited",
    "at": "at",
    "oClock": "o'clock",
    "unsubscribed": "unsubscribed",
    "every": "every",
    "pixel": "Pixel",
    "lagging": "Dear customer,<br><br>Access to VBus.net is currently lagging.<br>We are working on a solution and we apologize for any inconvenience. Thank you for your understanding.<br><br>Your VBus.net team",
    "offset": "Offset",
    "defaults": "Default settings",
    "deleteAll": "Delete all",
    "mustSelectOneOption": "You have to select at least one option!",
    "browserNotSupported": "Your browser is not supported!<br/>Please update to a current version.",
    "uploadErrorFile": "The file cannot be uploaded!",
    "errorSensor": "Sensor fault",
    "new": "new",
    "energyOffset": "Energy value offset",
    "weatherData": "Weather data of your location",
    "gridLiveSystem": "Grid pattern for easier positioning",
    "dailyEnergyValues": "Energy value daily summary",
    "overwriteWarning": "Existing data will be overwritten!",
    "maxFilesize": "max. file size",
    "factor": "Factor",
    "removeConversions": "Remove conversions",
    "chooseAltUnit": "Choose an alternative display unit…",
    "content": "Contents",
    "additionalContent": "Further contents",
    "choseContent": "Select contents",
    "publicLinkDiagrams": "Public links to diagrams",
    "publicLinkSchemes": "Public links to live systems",
    "deviceInfo": "Device information",
    "noEnergyValuesInFilter": "The filter selected does not contain energy values!",
    "warningSelectOnValue": "You have to select at least one filter value!",
    "heatQuantityDay": "Heat quantity day",
    "heatQuantityWeek": "Heat quantity week",
    "heatQuantityMonth": "Heat quantity month",
    "heatQuantityTotal": "Heat quantity total",
    "errorMessages": "Error messages",
    "temperatureValuesIn": "Temperature values in",
    "operator": "Operator",
    "systemType": "System type",
    "showLiveSystem": "Show live system",
    "confirmationMail": "Confirmation e-mail",
    "noConfirmationMailreceived": "Haven't received a confirmation e-mail?",
    "backupHintReceivers": "The confirmation e-mail has to be sent manually to all recipients.",
    "notificationInterval": "Notification interval",
    "oneEnergyInFilter": "The filter must contain at least one energy value!",
    "iUnderstand": "I understand.",
    "useCookies": "This website uses cookies.",
    "whatsNew": "What's new?",
    "nameTelefon": "Phone: +49 (0) 23 24/96 48-889",
    "nameFax": "Fax: +49 (0) 23 24/96 48-758",
    "nameEmail": "support@resol.de",
    "slide1": "Individual diagrams",
    "slide2": "Live systems",
    "slide3": "Automatic reports via e-mail ",
    "slide4": "How to",
    "nextSteps": "Next steps",
    "clickHereForMoreInformation": "Click here for more information…",
    "clickHere": "Click here…",
    "learnMore": "Click here to learn more…",
    "firstSteps": "First steps in VBus.net",
    "deviceName": "Device name",
    "forWeatherData": "For weather data",
    "dataloggerOrCommunicationModule": "DL2/DL3 Datalogger or KM2 Communication module",
    "downloadComplete": "Download complete",
    "automaticallyConfirmed": "Your e-mail address (under My profile) will be automatically active. New e-mail recipients have to confirm reception.",
    "downloaded": "downloaded",
    "templates": "Templates",
    "template": "Template",
    "addTemplate": "Add template",
    "noTemplateAvailable": "No template available for this system.",
    "templateAdded": "The template has been successfully added.",
    "channel": "Channel",
    "vbusConnection": "VBus connection",
    "optional": "optional",
    "unknownError": "An unknown error occurred",
    "menuLanguage": "Menu language",
    "reloadPageNow": "Reload this page now",
    "noDevicesFound": "No devices at VBus found.",
    "Haftungsausschluss": "Disclaimer",
    "PrivacyPolicy": "Privacy Policy",
    "TermsOfUse": "Terms of Use",
    "Verantwortlich55RStV": "Responsible for the contents according to § 55 Abs. 2 RStV (German Interstate Broadcasting Agreement)",
    "UmsatzsteuerIdUg": "VAT identification number",
    "VertGeschFuehrer": "Representative managing director",
    "DsgvoStart": "On 25 May the new General Data Protection Regulation (DSGVO) will come into force.",
    "DsgvoStarted": "On 25 May the new General Data Protection Regulation (DSGVO) came into force.",
    "DsgvoText": "The General Data Protection Regulation (DSGVO) contains extensive regulations and information obligations for processing and protecting personal data.",
    "acceptEulaMessage": "Accept Terms of Use and Privacy Policy",
    "weather": "Weather",
    "other": "Other",
    "fullscreen": "Full screen",
    "createFilterFirst": "You have to create a filter first…",
    "deviceFilter": "Device filter",
    "filterLisyByOnlineStatus": "Filter list by online status",
    "filterLisyByDeviceType": "Filter list by device type",
    "sorting": "Sort",
    "noDataLoaded": "No data could be loaded, please reload the page.",
    "showLegend": "Show legend",
    "symbol": "Symbol",
    "chooseHeatQuantities": "You can select up to 3 heat quantities",
    "twoFactorAuthentication": "Two-factor authentication (2FA)",
    "faq": "Frequently Asked Questions",
    "copyToClipboard": "Copy to the clipboard",
    "worst": "very bad",
    "bad": "bad",
    "weak": "weak",
    "good": "good",
    "strong": "strong",
    "automaticUpdate": "Automatic update in __SECONDS__ seconds",
    "axisSettings": "Axis settings",
    "engaged": "On",
    "off": "Off",
    "setup2FA": "Set up two-factor authentication",
    "remove2FA": "Remove two-factor authentication",
    "setupShort2FA": "Set up 2FA",
    "removeShort2FA": "Remove 2FA",
    "recovery2FA": "Recovery codes",
    "qr2FA": "QR code",
    "authenticator2FA": "Authenticator code",
    "code12FA": "Recovery codes can be used to access your VBus.net account, if you do not have access to your two-factor authentication app.",
    "code22FA": "Treat the recovery codes with the same attention as you would with your password. We recommend saving them in a password manager.",
    "code32FA": "The recovery codes can only be used for one single login. After a successful login they lose their validity.",
    "code42FA": "Save or print your recovery codes before proceeding to set up the two-factor authentication.",
    "code52FA": "If you lose the recovery codes and no longer have access to your two-factor authentication app, you will not be able to log in!",
    "print": "Print",
    "code62FA": "Please scan the barcode with your authenticator app. Then click on NEXT.",
    "code72FA": "Please enter the code of your authenticator app and click on FINISH.",
    "finish": "Finish",
    "invalid2FA": "The entered authenticator code is invalid. Please try again.",
    "success2FA": "Your two-factor authentication has been set up successfully!",
    "examples": "Help",
    "notPossibleMobile": "This feature is not available on a mobile device!",
    "dateAndTime": "Date and time",
    "deviceOverview": "Device overview",
    "deviceMap": "Device location map",
    "minimumSize": "minimum size",
    "maximumSize": "maximum size",
    "activation": "Activation",
    "switchToPro": "Switch to PRO access now",
    "documentNotFound": "The specified document could not be found on our server.",
    "startPage": "Start page",
    "clear": "Reset",
    "helpAndSupport": "Help & Support",
    "fileUpload": "File upload",
    "fileUploadText": "Loading file __FILENAME__  to  server. Please wait…",
    "unsupportedFileType": "File type not supported!",
    "invalidCharactersFilename": "The file name must not contain special characters or diacritics!",
    "invalidFileSize": "The file is too big! (max. 15 MB)",
    "errorLoadData": "Error during loading of the data!",
    "unknownExceptionError": "Unknown exception error",
    "demoDevice": "Demo device",
    "friendDevice": "Friend device",
    "temperatureSensor": "Temperature sensor",
    "switch": "Switch",
    "alreadyClaimedDemo": "You have already added a demo Datalogger to your account.",
    "function": "Function",
    "convertValue": "Convert value",
    "tokenNotWorking": "Too bad, this didn't work. Please try another token/coupon.",
    "divisionByZero": "Division by 0!",
    "passwordStrength": "Password strength",
    "chartType": "Chart type",
    "autoscale": "Scale automatically",
    "time": "Time",
    "factoryDefault": "Factory setting",
    "initialize": "Initialize",
    "addDataloggerCommunicationModule": "Click here to add a Datalogger or communication module to your account.",
    "twoFactorRemovedSuccessful": "Your two-factor authentication has been removed successfully!",
    "hideLegend": "Hide legend",
    "warningUnknownLivedata": "Error during reading the live data!",
    "default": "Default",
    "passwordIsEmail": "The password must not be identical to the e-mail address!",
    "unknownDevice": "Unknown device",
    "noSettingsAvailable": "No settings available!",
    "errorLoadImage": "Image could not be loaded!",
    "errorLoadWeather": "Weather data could not be loaded!",
    "errorLoadLiveSystem": "Live system could not be loaded!",
    "weekday": "Day of the week",
    "createdAt": "created at",
    "tooltip": "Tooltip",
    "subtitle": "Subtitle",
    "lastUpdated": "last updated",
    "preview": "Preview",
    "extendSubscription": "Extend subscription",
    "loginToExtendSubscription": "To renew your VBus.net subscription, you must first log in.",
    "orderedSubscription": "Ordered subscription",
    "yourAccount": "Your VBus.net subscription",
    "unlimited": "unlimited",
    "emailAlreadyExists": "E-mail address already exists",
    "selectDecices": "Select devices",
    "description": "Description",
    "decimals": "Decimals",
    "needInvoice": "You need an invoice?",
    "proAccount": "VBus.net PRO access",
    "businessAccount": "VBus.net Business access",
    "convertFilterValue": "Calculate with filter value",
    "doNotShowAgain": "Do not show this message again.",
    "toggle": "Show / hide all",
    "numberFormat": "Number format",
    "checkVBusConnection": "Please check the VBus connection between controller and {1}!",
    "liveDataNotUpToDate": "These live data are not up to date! Last update: {1}",
    "news": "News",
    "hide": "hide",
    "archive": "Archive",
    "noNewMessages": "No new messages",
    "messages": "Messages",
    "viewArchivedMessages": "View archived messages",
    "readNow": "read now",
    "customerOpinions": "Customer opinions",
    "globalErrorTitle": "Technical difficulties!",
    "globalErrorMessage": "Unfortunately there are currently technical problems. We are already working on a solution.",
    "globalSuccessTitle": "Technical problem resolved",
    "globalSuccessMessage": "VBus.net is fully available again after technical problems. If your data logger / communication module is still offline, please follow these instructions in the FAQs.",
    "endOfQuarter": "End of quarter",
    "lastQuarter": "Last quarter",
    "licenseText": "License text",
    "invalidToken": "Invalid token",
    "selectDay": "Select day",
    "selectCalendarWeek": "Select calendar week",
    "selectMonth": "Select month",
    "selectYear": "Select year",
    "calendarWeek": "Calendar week",
    "calendarWeekShort": "CW",
    "selectQuarter": "Select quarter",
    "dataloggerDL2Plus": "DL2 Plus Datalogger",
    "geodataFormatDecimal": "Decimal format e.g. 51.3970, 7.2169",
    "geodataFormatSexagesimal": "Sexagesimal format e.g. 51° 23' 49.5361\", 7° 13' 00.8945\"",
    "noData": "No data!",
    "automaticConversion": "Automatic conversion."
  },
  "vbusnet": {
    "email": {
      "confirmText": "Thank you for signing up with VBus.net. You can confirm your account through the link below:",
      "confirmMyAccount": "Confirm my account",
      "requestNewPassword": "Someone has requested a link to change your password, and you can do this through the link below.",
      "changeMyPassword": "Change my password",
      "didNotRequestThisText": "If you didn't request this, please ignore this e-mail.",
      "passwordWontChangeText": "Your password won't be changed until you access the link above and create a new one."
    },
    "demo_ownership_description": "This demo Datalogger provides data from a solar and heating system in western Germany. The most interesting VBus data fields are:",
    "demo_datalogger": "The demo Datalogger only has limited editing options."
  },
  "visualization": {
    "scheduledDownloadBodyAttachment": "Attached to this e-mail you will find your scheduled download.",
    "scheduledDownloadBodyNoAttachment": "This e-mail contains no scheduled download. There are probably no data for the period selected.",
    "scheduledDownloadSubjectDaily": "Your daily scheduled download",
    "scheduledDownloadSubjectWeekly": "Your weekly scheduled download",
    "scheduledDownloadSubjectMonthly": "Your monthly scheduled download",
    "report": "Report",
    "reportConfirmSubject": "Please confirm the new report.",
    "scheduledDownload": "Scheduled download",
    "scheduledDonwloadConfirmSubject": "Please confirm the new scheduled download.",
    "scheduledDownloadConfirmMessage": "If you wish to stay informed about the following scheduled download, click on the following link:",
    "scheduledDownloadUnsubscribe": "Unsubscribe from this scheduled download.",
    "reportConfirmMessage": "If you wish to stay informed about this report, click on the following link:",
    "reportUnsubscribe": "Unsubscribe from this report.",
    "nameImage": "Image",
    "nameFilter": "Filter",
    "nameDiagram": "Diagram",
    "nameScheme": "System",
    "maxCustomerImages": "Up to 3 customized images can be uploaded",
    "accepting": {
      "text": {
        "eula": "Accept End User License and Privacy Agreement",
        "accept": "Accept now"
      }
    },
    "downloadFormatTextTabWin": "Text (Tabulator, Windows)",
    "downloadFormatTextSemWin": "Text (Semicolon, Windows)",
    "downloadFormatTextTabLin": "Text (Tabulator, Linux)",
    "downloadFormatTextSemLin": "Text (Semicolon, Linux)",
    "downloadFormatVbus": "VBus Protocol Data",
    "nameDownload": "Download",
    "nameReport": "Report",
    "addScheduledDownload": "Add new scheduled download",
    "enabling": {
      "text": {
        "vbusnet": "Enable visualization with VBus.net",
        "eula": "By enabling this option you agree that your data will be stored with our service in accordance to the <a href='/eula'>End User License and Privacy Agreement</a>!"
      }
    },
    "allowParameterizationTextPlain": "Allow parameterization using the via address and the RESOL Parameterization Tool (RPT)",
    "settings": "Visualization settings",
    "allowParameterizationText": "Allow parameterization using the via address and the <a href='http://www.resol.de/index/software/sprache/en' target='_blank'>RESOL Parameterization Tool (RPT)</a>",
    "scheduledDownloads": "Scheduled downloads",
    "myImage": "My image",
    "myFilter": "My filter",
    "myScheme": "My system",
    "myDiagram": "My diagram",
    "myDownload": "My download",
    "myScheduledDownload": "My scheduled download",
    "myReport": "My report",
    "myWeather": "My weather",
    "downloadButton": "download",
    "saveButton": "save",
    "showButton": "show",
    "reportsSelectPeriod": "Please choose a period of time",
    "extendedReportsInfo": "Receive information on the status of your solar system regularly via e-mail. You can receive information on the yield (as a diagram) or error messages, etc. for example once a week.",
    "extendedReportsWeekInfo": "If you select \"Weekly\", you will receive data of the <strong>last 7 days</strong> from the day selected.",
    "extendedReportsMonthInfo": "If you select \"Monthly\" you will receive data of the  <strong>last complete calendar month </strong>on the first day of the month at the desired time.",
    "extendedReportsYearChart": "Annual overview",
    "extendedReportsWithYearChart": "With annual overview",
    "extendedReportsFilterInfo": "A diagram will be created for a data point selected. An annual summary will be created, too, if you so wish.",
    "sendReportAfterSave": "Send report after saving.",
    "sendScheduledDownloadAfterSave": "Send download after saving.",
    "sendScheduledDownloadNow": "Send scheduled download now",
    "sendReportNow": "Send report now",
    "sendScheduledDownloadNowDialog": "Do you want to activate your scheduled download now and receive it afterwards via e-mail?",
    "sendReportNowDialog": "Do you want to activate your report now and receive it afterwards via e-mail?",
    "scheduledDownloadSubjectQuarter": "Your quarterly report"
  },
  "monitoring": {
    "weeklyReport": "Your weekly report",
    "monthlyReport": "Your monthly report",
    "notificationConnectMail": "You will receive an e-mail as soon as the connection to the Datalogger has been re-established.",
    "notificationDisconnected": "The connection to the device is interrupted!",
    "notificationStillDisconnected": "The connection to the device is still interrupted!",
    "notificationDisconnectedNoMail": "You will not receive further e-mails concerning the interruption of the connection.",
    "notificationConnected": "The connection to the device has been re-established.",
    "errormaskTrue": "Error mask reports an error",
    "errormaskFalse": "Error mask reports no errors",
    "mailer": {
      "warning": {
        "subject": "Warning"
      },
      "error": {
        "subject": "Error"
      },
      "notificationConfirm": {
        "subject": "Please confirm the new notification."
      },
      "connection": {
        "subject": "Connection status"
      },
      "notification": {
        "message": "If you wish to stay informed about this notification, click on the following link:",
        "urlText": "Confirm this e-mail address.",
        "unsubscribe": "Unsubscribe from this notification."
      },
      "userText": "User text"
    },
    "thresholdTrue": "Limit value reached",
    "repealed": "resolved",
    "notification": "Notification",
    "statusHasChanged": "The status of one of your conditions in the following notification has changed.",
    "allConditionsAreFulfilled": "All conditions in the following notification are fulfilled.",
    "notificationConfirmed": "Your e-mail address has been successfully confirmed.",
    "notificationAlreadyConfirmed": "Your e-mail address has already been confirmed.",
    "notificationInvalidToken": "Invalid confirmation code!",
    "timePeriod": "Period of time",
    "receiver": "Recipient",
    "addNewReceiver": "Add new recipient",
    "errorOccurred": "Error occurred",
    "errorEliminated": "Error eliminated",
    "add": {
      "notification": "Add new notification",
      "action": "Add new action"
    },
    "notificationConnectionMessage": "The connection to your device will be automatically monitored!<br> If the device is not to connected to VBus.net for more than {1} minutes, you will receive an e-mail informing about the interruption of the connection. You will be informed about the interrupted connection twice after 24 hours respectively and you will receive an e-mail as soon as the connection has been re-established.",
    "errorLog": "Error log",
    "myNotification": "My notification",
    "conditions": "Conditions",
    "addNewCondition": "Add new condition",
    "selectDatapoint": "Select datapoint",
    "actions": "Actions",
    "allConditionsFulfilled": "all conditions must be fulfilled",
    "oneConditionFulfilled": "at least one condition must be fulfilled",
    "message": "Message ",
    "hintNotification": "You need to add at least one condition and one action to save a notification!",
    "edit": {
      "notification": "Edit notification"
    },
    "delete": {
      "notification": "Delete notification?"
    },
    "criterion": "Criterion",
    "delay": "Delay",
    "trippingTime": "Tripping time",
    "receivers": "Recipients",
    "numberOfConditions": "Number of conditions",
    "allConditionsFulfilled ": "all conditions must be fulfilled",
    "oneConditionFulfilled ": "at least one condition must be fulfilled",
    "addNewTemperatureNotification": "Add new temperature notification",
    "addNewErrorNotification": "Add new error notification",
    "overriding": "overriding",
    "lower deviation": "lower deviation",
    "warning": {
      "value": "Warning value "
    },
    "error": {
      "value": "Error value"
    },
    "numberOfActions": "Number of actions",
    "action": "Action",
    "relatedActions": "Related actions",
    "threshold": "Threshold",
    "warningThreshold": "Warning threshold",
    "errorThreshold": "Error threshold",
    "absoluteValue": "Absolute value",
    "difference": "Difference",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "greaterOrEqual": "greater than or equal to",
    "lessOrEqual": "less than or equal to",
    "greaterThan": "greater than",
    "lessThan": "less than",
    "unequal": "unequal",
    "dailyReport": "Your daily report",
    "reportMessageBodyAttachment": "Please find attached your report.",
    "reportMessageBodyNoAttachment": "This e-mail contains no report. There are probably no data for the period selected.",
    "currentValue": "Current value",
    "condition": "Condition",
    "disconnectionNotification": "Disconnection notification",
    "noDisconnectionNotification": "The connection to your device is not monitored!"
  },
  "account": {
    "emailNewConfirmation": "Confirm new e-mail address",
    "changeEmailBodyText": "You have changed your e-mail address. To confirm the new address, click on the link below:",
    "activation": {
      "error": "An error has occurred. Please repeat the previous action."
    },
    "changeEmailSuccessful": "The new e-mail address has been successfully confirmed.",
    "emailNew": "New e-mail address",
    "changeEmail": "Change e-mail address",
    "areYouSure": "Are you sure?",
    "username": "User name",
    "cancel": "Cancel my account",
    "unhappy": "Unhappy?",
    "deleteMyAccount": "Cancel my account",
    "changePassword": "Change password",
    "create": {
      "user": "Create User account"
    },
    "edit": {
      "user": "Edit User account"
    },
    "password": {
      "CurrentPasswordMessage": "We need your current password to confirm your changes"
    },
    "understoodEulMessage": "I have read and understood the <a href='/eula'>end-user license agreement</a>.",
    "emailConfimationText": "A message with a confirmation link has been sent to your e-mail address. Please open the link to activate your account.",
    "passwordNew": "New password",
    "passwordOld": "Old password",
    "passwordNewConfirmation": "New password confirmation",
    "userData": "User data",
    "invalid_token": "You have successfully activated your VBus.net account. You can now log in with your login credentials.",
    "emailOrUsername": "e-mail or user name",
    "changeEmailInServices": "If you change the e-mail address, it will automatically be changed in the following services:",
    "changeEmailConfirmation": "A confirmation e-mail has been sent to __EMAIL__. Please click on the link in the e-mail to confirm the new address.",
    "acceptEulaMessage": "Accept Terms of Use and Privacy Policy",
    "AcceptEula": "In order to continue using VBus.net, you have to accept our Terms of Use and Privacy Policy."
  },
  "order": {
    "yourOrderSubject": "Your order with VBus.net",
    "salesTaxIdentificationNumber": "VAT Reg.No.",
    "positions": "Positions",
    "oneYearPro": "1 x VBus.net PRO access (1 year) 39,00 €",
    "bankDetails": "Bank account",
    "paymentDetails": "Due to the desired payment method via bank transfer, we will immediately send you the invoice via e-mail. Please use the bank account information indicated in the e-mail for bank transfer and indicate the invoice number and your VBus.net e-mail address, so that we can allocate your payment to your order.",
    "activatedAfterPayment": "After we have received your payment, your VBus.net PRO access will be activated.",
    "upToThreeDays": "This process may take up to 3 days.",
    "reference": "Reason for payment",
    "paymentMethod": "Payment method",
    "order": "Order ",
    "confirmation": "You will receive an order confirmation via e-mail with payment information in the next few minutes. After we have received your payment, your VBus.net PRO access will be activated.",
    "paymentPaypal": "Payment via Paypal",
    "paymentBankTransfer": "Payment via bank transfer",
    "paymentPerMail": "Invoice via e-mail to",
    "now": "Order now",
    "linkAgb": "Our general terms & conditions apply",
    "mustConfirm": "You have to accept the order first",
    "VbusVisulizationVor2013": "Order VBus.net access for DL2 built before 2013",
    "withCost": "Order (with costs) here",
    "VbusVisulization": "Yes, I would like to order the VBus.net visualization access",
    "description": "The one-time fee of the VBus.net visualization access is <b>20,- EUR (VAT included)</b>.<br/>A few minutes after ordering you will get an order confirmation via e-mail.",
    "umstid": "VAT Reg.No.",
    "billingAdressAdd": "Billing address, if different from contact address",
    "dl2": {
      "bevor2012": "VBus.net access for DL2 before 2013",
      "thanks": "Thank you for choosing VBus.net. Your access is now activated. We hope you will enjoy the advanced functions."
    },
    "vatIncluded": "VAT included",
    "salutaion": "Dear",
    "thanksForOrder": "thank you for your order dated",
    "orderDetails": "Details of your order:",
    "emailReference": "For bank transfer, please indicate your VBus.net e-mail address as the reason for payment, so that we can allocate your payment to your order. ",
    "sendOrder": "Submit order",
    "accountUpdated": "Your VBus.net subscription has been updated.",
    "currentSubscription": "Previous subscription:",
    "newSubscription": "New subscription:",
    "validUntil": "valid until"
  },
  "professional": {
    "willExpire": "Your VBus.net PRO access will expire within {1} days",
    "order": {
      "euvat": {
        "explanation": "I hereby confirm that my principal residence is in the above-mentioned country. This serves as the basis for calculating the VAT (buyers within the EU only)."
      },
      "information": {
        "required": "Information required"
      },
      "require": {
        "text": "The vendor of this item requires the following information:"
      },
      "received": "We have received your PayPal payment.",
      "thanks": "Thank you for choosing VBus.net PRO. Your VBus.net PRO access is now activated. We hope you will enjoy the advanced functions.",
      "redirect": {
        "wait": "Your order is now being sent to PayPal.",
        "wait2": "This may take several seconds."
      }
    },
    "own": {
      "scheme": {
        "images": "Custom system images"
      }
    },
    "data": {
      "live": {
        "time": "Data storage"
      }
    },
    "function": {
      "overview": "Overview of VBus.net accesses"
    },
    "time": {
      "live": {
        "data": "Data refresh"
      }
    },
    "enhanced": {
      "scheme": {
        "editor": "Advanced system editor"
      }
    },
    "dl2": {
      "inclusive": "Incl. access for DL2 before 2013"
    },
    "error": {
      "protocol": "Error protocol"
    },
    "monitoring": "Notifications",
    "friendship": {
      "function": "Share device"
    },
    "subscription": {
      "name": {
        "basic": "Basic",
        "professional": "PRO"
      }
    },
    "subscriptionRequired": "VBus.net PRO access is required for this action.",
    "expired": "Expired",
    "extendOneYear": "Extend by 1 year (with costs)"
  },
  "extend": {
    "professional": {
      "account": "Extend PRO access now"
    }
  },
  "address": {
    "herr": "Mr",
    "frau": "Ms",
    "billingAddress": "Billing address",
    "firma": "Company",
    "anrede": "Form of address",
    "vorname": "Name",
    "nachname": "Surname",
    "strasse1": "Street 1",
    "strasse2": "Street 2",
    "postleitzahl": "Postcode",
    "ort": "City",
    "plz": "Postcode",
    "land": "Country",
    "businessCustomer": "Business customer",
    "privateCustomer": "Private customer",
    "email": "E-mail",
    "telefon": "Phone",
    "fax": "Fax",
    "internet": "Internet",
    "strasse": "Street ",
    "bundesland": "County",
    "kundennummer": "Customer no.",
    "webseite": "Website",
    "name": {
      "first": "First name",
      "last": "Last name"
    },
    "address": "Address",
    "kunde": "Customer"
  },
  "backbone": {
    "validation": {
      "required": "is required",
      "email": "must be a valid email address",
      "acceptance": "must be accepted",
      "min": "must be greater than or equal to {1}",
      "max": "must be less than or equal to {1}",
      "range": "must be between {1} and {2}",
      "length": "must be {1} characters",
      "minLength": "must be at least {1} characters",
      "maxLength": "must be at most {1} characters",
      "rangeLength": "must be between {1} and {2} characters",
      "oneOf": "must be one of: {1}",
      "equalTo": "must be the same as {1}",
      "digits": "must only contain digits",
      "number": "must be a number",
      "url": "must be a valid URL",
      "inlinePattern": "is invalid",
      "matchPasswords": "passwords are not identical",
      "matchEmail": "E-mail addresses are not identical.",
      "compareWithOriginalEmail": "New e-mail address must not be identical to current address."
    }
  },
  "errors": {
    "messages": {
      "already_confirmed": "was already confirmed, please try signing in",
      "prohibited": {
        "ownership": {
          "one": "1 error prevented this device ownership from being saved:",
          "others": "2 errors prevented this device ownership from being saved:"
        }
      }
    }
  },
  "passwordWrong": "The current password is incorrect. Please check your entry!",
  "ownership": {
    "invalidToken": "Invalid access token",
    "alreadyClaimed": "This device has already been added.",
    "successfully": {
      "created": "The device has been successfully updated.",
      "deleted": "The device has been successfully deleted!"
    },
    "alreadyInOwnAccount": "This device was available in your account. If you want to restore it, please select it from the list.<br>If you want to add the device as New device, previous data will not be restored.",
    "alreadyInOtherAccount": "This device has already been added to an account!<br> The device has to be deleted or, if it is in your possession, set back.<br>Please pay attention to the notes in the manual.",
    "restoreThisDevice": "Restore this device",
    "deleteOwnership": "Delete device",
    "addAsNew": "Add as New device",
    "confirmText": "Do you really want to delete this device?",
    "claim": {
      "online": {
        "message": "In order to add a device, your Datalogger or Communication module must be connected to the Internet."
      }
    },
    "via_tag": "Via tag",
    "editing": "Edit device",
    "description": {
      "via_tag": "Enter a Via tag and save it in order to customize your Via address. When the Via tag has been saved, you can use the via address to access your system over the Internet.<br/>The Via tag must have at least 3 characters, starting with a lower-case letter. It may contain lower-case letters, numbers and hyphens."
    },
    "claimedSuccessful": "Your __PRODUCT-NAME__ has been successfully added.",
    "getFirstDataHeader": "Data query in progress…",
    "getFirstDataSubtext": "Connection is being established. This process may take several minutes…",
    "dataReceivedSuccessfully": "Data query successful",
    "initSettingsText": "Please enter the following information on your device:",
    "claimOwnFriendshipToken": "You cannot use your self-created access code!",
    "adjustTimestamps": "Adjust timestamp",
    "adjustTimestampsInfo": "With this option, your live data always gets a current time stamp, even if a different time is set on your device (KM2, DL2, DL3 etc.). Only activate this option if you have problems with the timeliness of your data and curve progressions are displayed in a disordered manner in the diagram.",
    "openSettings": "Open device settings"
  },
  "viatag": {
    "alreadyInUse": "This Via tag is already in use!"
  },
  "demo": {
    "temperature": {
      "collector": "Collector temperature",
      "storage": {
        "below": "Tank temperature (base)",
        "above": "Tank temperature (top)"
      }
    },
    "pump": {
      "speed": "Solar pump speed"
    },
    "valve": {
      "storage": "Tank valve"
    },
    "maximum": {
      "count": {
        "exeed": "Demo Datalogger could not be enabled. Every user is able to add only one demo Datalogger!"
      }
    }
  },
  "error": {
    "messages": {
      "not_found": "Not found"
    },
    "noData": {
      "aviable": "No data are available for the adjustments selected!"
    },
    "tooManyRequests": "Too many requests, please try again later."
  },
  "coupon": {
    "claimedSuccessful": "Your coupon has been redeemed successfully. Your PRO access has now been activated / extended by:",
    "alreadyClaimed": "This coupon has already been used",
    "invalidToken": "Invalid coupon code",
    "youHaveACoupon": "Do you have a coupon?",
    "code": "Coupon code",
    "redeemCoupon": "Redeem coupon",
    "name": "Coupon",
    "enterCouponCode": "Enter coupon code here",
    "redeemAnotherCoupon": "Redeem another coupon",
    "deviceWithTestPro": "Your new device has a coupon - est VBus.net PRO for 30 days free of charge",
    "redeemNow": "Redeem coupon now ",
    "redeemLater": "Redeem coupon later ",
    "redeemLaterText": "You can also redeem the coupon later - your code is: __COUPON__ (it can also be found on the back cover of the manual)."
  },
  "device": {
    "notFound": "Device not found.",
    "newFirmwareAvailable": "A new firmware version __VERSION__ is available!",
    "serial": "Serial",
    "version": "Version",
    "build": "Build",
    "product": "Product",
    "fw_feed": "Fw feed",
    "firmware_feed": "Firmware feed",
    "newFirmware": "New firmware available",
    "claimInfoPorts": "Please note that your Datalogger (DL2/DL3) or communication module (KM2) has to be connected with the internet and must have access to VBus.net! In order to enable VBus.net access, the Datalogger or communication module must have unconditional access to the ports 80 and 1194 / 1195.",
    "claimInfoLed": "The operating control LED must permanently glow green",
    "claimVbusActivated": "VBus.net must be activated",
    "claimInfoNetwork": "has to be indicated in the Network menu",
    "claimInfoNoVisualizationSettings": "There are no visualization settings for this device."
  },
  "dataProtection": {
    "Einwilligung": "Data protection consent",
    "EinwilligungWiderruf": "You can revoke your consent via <span class=\"nobr\">e-mail</span> to vbus.net@resol.de at any time.",
    "EinwilligungText1": "I have read and understood the URL_NUTZUNG as well as the URL_DATENSCHUTZ and I accept them."
  },
  "eula": {
    "acceptWarning": "You have to accept the End User License and Privacy Agreement in order to continue.",
    "agb": "Terms of Use",
    "privacyPolicy": "Privacy Policy",
    "reaccept": "We have changed our End User License and Privacy Agreement. You need to agree in order to continue.",
    "name": "End User License and Privacy Agreement",
    "acceptText": "By clicking on Sign up, you agree wih our __eula__ ."
  },
  "filter": {
    "add": "Add new filter",
    "showAll": "Show all",
    "edit": "Edit filter",
    "name": "Filter name",
    "addToFilter": "Add to filter",
    "show": "Show",
    "mustBeAString": "Must be a string",
    "atLeastOneDatapoint": "You have to add at least one data field to the filter",
    "showUsed": "Edited default settings only",
    "pleaseSelectDatapoints": "Please select data points from the list of your live data.",
    "noFilterData": "No filter data available!",
    "changedLiveData": "Your live data have changed since the filter was created!",
    "noConversionAvailable": "No conversion available",
    "conversionError": "Error in the conversion!",
    "changedLiveDataShowOldValues": "{1} filter values are no longer available in your live data and cannot be edited!",
    "maxValues": "A maximum of {1} filter values are allowed!",
    "datapointNotEditable": "You cannot edit this data point!"
  },
  "day": {
    "today": "Today",
    "yesterday": "Yesterday",
    "lastTwo": "Last 2 days",
    "lastSeven": "Last 7 days",
    "lastThirty": "Last 30 days",
    "currentMonth": "Current month",
    "lastMonth": "Last month",
    "sa": "Sat",
    "So": "Sun",
    "do": "Thu",
    "Di": "Tue",
    "Mi": "Wed"
  },
  "ademe": {
    "module": "Module",
    "filter": {
      "header": "Filter by modules",
      "units": "Filter by units",
      "allModules": "All modules",
      "allUnits": "All units"
    },
    "report": {
      "add": "Add new report",
      "edit": "Edit report",
      "save": "Save report"
    },
    "add": {
      "header": "ADEME: "
    },
    "systemType": "System type",
    "systemNumber": "System no.",
    "value": "Value",
    "values": "Values",
    "error": {
      "systemNumberStart": "System number must start with IS! ",
      "systemNumberLength": "System number must be 12 to 14 characters long!",
      "systemNumberCharacter": "System number contains invalid characters!",
      "systemNumberYear": "System number does not contain a valid year!",
      "SystemType": "<br />Please select a system type!"
    },
    "hint": {
      "successSaveHeader": "Successful!",
      "successSaveBody": "Your data has been saved successfully!",
      "warningSaveHeader": "Warning!",
      "warningSaveBody": "You have already saved data! Changes may have an effect on your ADEME Funding!"
    },
    "select": {
      "systemType": "Select system type"
    },
    "system": "System",
    "units": {
      "Energy": "Energy",
      "Temperature": "Temperature",
      "CubicMeter": "Cubic meter"
    }
  },
  "sideBar": {
    "filters": "Filters",
    "images": "Images",
    "liveSchemes": "Live systems",
    "diagrams": "Diagrams",
    "downloads": "Downloads",
    "reports": "Reports",
    "notifications": "Notifications",
    "visualization": "Visualization",
    "friends": "Share device",
    "dashboard": "Dashboard",
    "parametrization": "WebRPT Parameterization",
    "discovery": "DeviceDiscoveryTool",
    "utilities": "Utilities",
    "myVBusNet": "My VBus.net",
    "status": "Status",
    "ademe": "ADEME",
    "monitoring": "Monitoring"
  },
  "choose": {
    "download": {
      "format": "Please choose a download format"
    },
    "system": "Please choose a system",
    "background": {
      "image": "Please choose a background image"
    },
    "filter": "Please choose a data selection",
    "periodOfTime": "Please choose a period of time",
    "image": "Select image",
    "device": "Select device"
  },
  "plan": {
    "valid": {
      "until": "Valid until"
    },
    "order": {
      "here": "Order here"
    },
    "days": {
      "left": "Days left"
    },
    "trial": {
      "expired": "TRIAL PERIOD HAS EXPIRED"
    }
  },
  "subtitle": {
    "myDevices": "My Devices",
    "myVirtualDevices": "My virtual devices"
  },
  "unit": {
    "add": "+ Add value",
    "sub": "- Subtract value",
    "mul": "* Multiply value",
    "div": "/ Divide value",
    "inv": "1 / value (reciprocal value)",
    "calculate": "Convert unit"
  },
  "parameterization": {
    "supportedDevicesText": "The following devices can at present be parameterized via VBus.net:",
    "rptWebseite": "If your device is not yet supported by VBus.net, you can also use our RESOL Parameterization Tool RPT. Further information can be found on our website:",
    "connectionRptServer": "Connection to the WebRPT server is being established…",
    "connectionRptServerError": "The connection to the WebRPT server could not be established.",
    "connectionRptServerRetry": "Check connection again…",
    "checkConncectionToDevice": "Check parameterisation ability",
    "notParameterizable": "Cannot be parameterised",
    "vbusPassword": "VBus password",
    "passwordHint": "Enter the remote access password (factory setting: vbus).",
    "loadConfig": "Load configurations stored:",
    "pleaseEnterVbusPassword": "Please enter the VBus password and click on CONTINUE.",
    "dataTransmission": "Data transfer in progress…",
    "configurationNotLoadable": "Configuration not loadable!",
    "deleteConfiguration": "Delete this configuration?",
    "errorTimeout": "Timeout during connection process to Datalogger / communication module",
    "errorConnection": "Datalogger / communication module not connected to VBus.net",
    "errorNetwork": "Please check your network wiring and / or Datalogger /communication module",
    "wrongVbusPassword": "Incorrect VBus password!",
    "errorNoResponse": "The controller does not answer!",
    "errorVbus": "Please check the VBus cable and / or the controller.",
    "errorCode": "Error code",
    "errorLogin": "WebRPT login expired!",
    "login": "Please log in again!",
    "notParametrizable": " cannot be parameterised.",
    "changedController": "The controller has changed!",
    "withoutConfiguration": "Start without configuration",
    "brokenConfiguration": "Defective configuration ",
    "proRequired": "PRO access required",
    "rpt": "RPT note",
    "start": "Parameterize now",
    "connectionController": "Connection to the controller is being established…",
    "noConnectionVBusnet": "The connection to VBus.net could not be established!",
    "checkStep1": "Please check your DL2/DL3/KM2 and, if necessary, its network configuration as well as your Internet and firewall settings.",
    "noConnectionController": "The connection to the controller could not be established!",
    "checkStep2": "Please check, if the controller is ready and if the VBus cable has been connected correctly.",
    "wrongPassword": "Invalid VBus password!",
    "checkStep3": "Please check your entry and then click on CONTINUE.",
    "controllerNotParameterizable": "Controller cannot be parameterised!",
    "checkStep4": "Please check, if your controller supports parameterisation.",
    "connectionVbusnet": "Connection to VBus.net",
    "controller": "Controller",
    "checkVersion": "Version check",
    "configurable": "Can be parameterised?",
    "getSupportedDevices": "Searching for supported devices…",
    "foundSupportedDevices": "The following devices found can be parameterized depending on their software version:",
    "noSupportedDevices": "No supported devices found!",
    "configuration": "Configuration",
    "notAllowed": "Parameterization not allowed!"
  },
  "parametrization": {
    "header": "RPT Parameterization Tool",
    "supportedDevices": "The following RESOL controllers are supported:",
    "subHeader": "Software for parameterizing RESOL controllers",
    "downloadFree": "Download the RPT software free of charge",
    "rptSoftware": "RPT software (Version 1.9)",
    "licenseNote": "License note",
    "manualPdf": "Manual (PDF)",
    "systemRequirements": "System requirements: Windows 7, in compatibility mode: Windows 8.1 / 10, 32 bit Java from version 1.6",
    "howToStepOne": "Start the RPT software on your PC, then select <strong>Connect...</strong> in the <strong>Communication</strong> menu.",
    "howToStepTwo": "Select the device in use and enter the via tag into the <strong>URL/IP address</strong> field.",
    "howToStepThree": "You can find the via tag in the following menu:",
    "howToStepFour": "Enter your password. If you have not changed your passwort, yet, it is <strong>vbus</strong>.",
    "howToStepFive": "Click on <strong>Connect</strong>. You can parameterize your controller now.",
    "deviceNotListed": "If your controller is not on this list, please use the",
    "rscSoftware": "RSC software",
    "requiredDevices": "In order to use the RPT Parameterization Tool, you will need the following RESOL devices:",
    "youNeedDevice": "You don't have a RESOL device, yet? Click <a href=\"http://www.resol.de/\" target=\"_blank\">here</a> to visit our website. "
  },
  "settingsDocumentation": {
    "errorTryAgain": "Please try again later. If the problem persists, please contact the RESOL support team: support@resol.de",
    "description": "The Settings Documentation Generator creates a Documentation (PDF) from your SET file.",
    "selectSetFile": "Select SET file",
    "documentTitle": "Document title",
    "convertSetFile": "Convert SET file",
    "startConversion": "Start conversion",
    "downloadPdfFile": "Download PDF file",
    "settingsDocumentationGenerator": "Settings Documentation Generator",
    "optionalTitel": "Optional title",
    "invalidSetFile": "Invalid SET file format",
    "incompatibleSetFile": "The provided file is not a SET file compatible with a RESOL DeltaSol MX 2.xx. Please try a different file.",
    "convertionFailed": "Conversion failed",
    "errorConversionTookToLong": "The conversion took too long to complete.",
    "converting": "Converting",
    "errorAllowedCharacters": "Only letters, numbers, dashes (-), spaces ( ) and underscores (_) are allowed in title.",
    "pdfFile": "PDF file"
  },
  "passwordSame": "The new password is identical to the current password.",
  "delete": {
    "entry": {
      "text": "This entry cannot be deleted because it is used in the following functions:",
      "header": "Delete entry",
      "question": "Do you really want to delete the entry <span id='myModalName' class='delete_question'></span> ?"
    }
  },
  "unitFamily": {
    "temperature": "Temperature",
    "volume": "Volume",
    "pressure": "Pressure",
    "power": "Power",
    "energy": "Energy",
    "volumeFlow": "Flow rate",
    "time": "Time"
  },
  "deleteAccount": "All your data as well as your VBus.net access will be irrevocably deleted. This process cannot be undone! Please enter the current password to confirm.  ",
  "passwordRequired": "Please enter your current password!",
  "yesDeleteAccount": "Yes, delete all data",
  "topBar": {
    "editProfile": "My profile",
    "registerHere": "Sign up now for free",
    "imprint": "Imprint",
    "register": "Sign up",
    "home": "Home"
  },
  "passwordHackInfo": "IT specialists need <b>TIME</b> in order to calculate this password!",
  "changePasswort": {
    "noToken": "No valid token for resetting the password has been found! Please note that the token is valid for 1 day only. Request the reset password link again, if necessary."
  },
  "twoFactorTokenAlredyExists": "The recovery codes can only be created once.",
  "dataviewer": {
    "title": "For visualizing system data via SD memory card. The data will be displayed in a comprehensive progress chart. You  neither need a Datalogger nor a Communication module. The controller does not have to be connected to the Internet. You data will stay with you - visualizations will not be stored."
  },
  "diagram": {
    "add": "Add new diagram",
    "allow": {
      "public": "Create a link for viewing the diagram"
    },
    "edit": "Edit diagram",
    "data": "Data",
    "height": "Height",
    "width": "Width",
    "noDataSelected": "No data selected.",
    "min": "Min",
    "max": "Max",
    "publicUrlCustomRangeWarning": "The selection <strong>Custom period of time</strong> is not available for public diagrams!"
  },
  "vbus": {
    "deactivateFilter": "VBus Protocol Data file contains all values. The filter function will be disabled.",
    "net": "VBus.net"
  },
  "download": {
    "add": "Add new download",
    "edit": "Edit download",
    "noDataForSelectedPeriod": "There are no data for the period selected!",
    "forOtherOs": "Download for other operating system"
  },
  "tooltip": {
    "filter": {
      "standardvorgabe": "You can save each filter as a default setting and use it as a template for new filters. You can create one default setting per device."
    }
  },
  "default": {
    "filter": {
      "load": {
        "msg": "Load default setting",
        "text": "Use this filter as the default setting"
      },
      "values": "Default filter settings",
      "exists": {
        "text": "You have already created a filter for this device."
      },
      "default": {
        "text": "Would you like to use this filter as the default settings?",
        "create": "Create default settings for this system",
        "load1": "Add default settings to the list",
        "load2": "Modify list with default settings",
        "load3": "Modify list with default settings and add missing values"
      }
    },
    "load": "Load",
    "default": {
      "notexists": {
        "text": "You have not yet provided a default setting for this device.",
        "text1": "Would you like to provide a default setting now?"
      },
      "create": {
        "text": "Create default setting"
      }
    }
  },
  "heating": {
    "systems": "Heating systems"
  },
  "solar": {
    "systems": "Solar systems",
    "collectors": "Collectors",
    "storages": "Tanks",
    "collector": "Collector",
    "system": "Solar system"
  },
  "image": {
    "add": "Add new image",
    "name": "Image name",
    "validMimeType": "Image format must be .jpg, .jpeg, .png or .gif ",
    "edit": "Edit image",
    "maxFilesize": "max. file size",
    "delete": "Really delete image?"
  },
  "scheme": {
    "allow": {
      "public": "Create a link for viewing the system"
    },
    "setDatapoints": "Set data field positions",
    "add": "Add new system",
    "edit": "Edit system",
    "publicUrl": "By means of a public link, you will have access to your live system, even if you are not logged-in on VBus.net. You can share this link with people who are not signed up on VBus.net. You can also add this link to your own website in order to show your live system."
  },
  "reports": {
    "dotDayOfMonth": "day of the month",
    "dotDay": ".day every",
    "dotMonth": ".month at"
  },
  "please": {
    "wait": "Please wait..."
  },
  "parameterizationsettings": {
    "translation": "Parameterization settings",
    "makeShureNotDefaultPasswordText": "Please make sure that the Parameterization password in the web interface of your Datalogger is not set to its default value of 'vbus'.",
    "changePasswordText": "Click here to change the Parameterization password in the web interface of your Datalogger:"
  },
  "claim": {
    "howToFindToken": "How to find your access token"
  },
  "index": {
    "claimANewDevice": "Add new device",
    "editThisInformation": "Edit this information",
    "welcomeToVBusnet": "Welcome to VBus.net!",
    "youNotHaveADataloggerYet": "You do not have a device yet? Click here to add a demonstration logger to your account...",
    "noVideo": "No video? Try these alternative sources",
    "videoDownload": "Video download",
    "orOn": "or on",
    "ifYouDoNotHaveADataloggerYet": "If you do not have a device yet, but would like to give VBus.net a try, you can add a demonstration Datalogger by following these steps",
    "list": {
      "logInToVBusNet": "Log in to VBus.net",
      "addADemonstationLogger": "Add a demonstration Datalogger to your account",
      "activateOptionDatalogger": "Activate the option in the Datalogger",
      "getActivationToken": "Get the access token",
      "claimLoggerWhithToken": "Add your device by entering the token"
    },
    "download": {
      "datasheet": "Download the<br />VBus.net datasheet here!",
      "manual": "Download the<br />VBus.net manual here!"
    },
    "text1": "VBus.net is an Internet service hosted and run by <a href=“http://www.resol.com“>RESOL</a>, allowing you to access your RESOL device from anywhere in the world with just a few clicks.",
    "text3": "VBus.net is all about the data of your RESOL controller. But to get access to this data in the first place, you need to claim your device. You can do that in four very easy steps:",
    "noVideoPlaybackText": "No video playback capabilities, please download the video below.",
    "general": {
      "register": "Test it now without costs or obligations"
    },
    "howto": {
      "question": "You want to know how it works?"
    },
    "customer": {
      "examples": "You want to see how our customers use VBus.net?"
    },
    "title": "Visualize your system data ",
    "text2": "Visualize temperature progress, create customized live systems and diagrams free of charge.",
    "liveSystemExample": "Example of a live system created with VBus.net.",
    "createNewVirtualDevice": "Create virtual device"
  },
  "show": {
    "liveData": "Show live data"
  },
  "friendship": {
    "createToken": "Create an access token",
    "createdFriendships": "Access tokens created",
    "createAccessTokenText": "<b>Share your data with other VBus.net users</b><br/><br>Create a new access token for VBus.net users in order to grant them access to your data. Thus, these users can create their own visualizations that use your system data. <br/><br/>The users can claim this access token as a new device in their own VBus.net account under <b>My devices <i class=\"fa fa-angle-right\"></i> Add new device</b>. Just give them the access token.<br/><br/> Of course, you can always withdraw their access.",
    "featureNotAvailable": "This feature is not available for a friend device!"
  },
  "feedbackForm": {
    "thankYou": "Thank you for your feedback.",
    "yourOpinion": "Your opinion is important to us!",
    "helpText": "You want to help improve VBus.net or tell us your ideas, wishes and suggestions? Please use the feedback form.",
    "assessmentText": "Please evaluate the following:",
    "scopeOfFunctions": "Functional range",
    "userFriendliness": "User friendliness",
    "use": "Benefit",
    "response": "Your feedback will be processed under the number _ID_. ",
    "yourSatisfaction": "Your satisfaction"
  },
  "imprint": {
    "chief": "Managing director",
    "court": "Register court",
    "registration": {
      "number": "Register number"
    },
    "vat": "VAT identification number according to § 27 a VAT Act ",
    "poweredBy": "Powered by",
    "technic": {
      "design": "Internet technique & design"
    }
  },
  "sales": {
    "tax": {
      "act": "(Umsatzsteuergesetz, German legislation)"
    }
  },
  "howto": {
    "vbusdotnet": "With VBus.net you are able to generate live views of your system. You can also create diagrams of data recorded over a defined period of time or download them.",
    "storageDuration": "Your data will be stored for 90 days (Basic) or 1 year (PRO).",
    "liveData": "View live data values of your system.",
    "filter": "Create selections of your data points for further use in your downloads, live systems and diagrams. You are able to rename the data points and pick a custom color for your diagram line.",
    "images": "Save images for further use in your live systems. You can choose an image from a selection of vendor images or you can upload your own custom image.",
    "downloads": "Download the system data recorded over a defined period of time. You can save a download for further use or you can download data directly. ",
    "liveSchemes": "Show your live data on an image of your system. You can set the position of each data point by simply dragging and dropping the element to the image. As soon as a data point is dropped, its position will be saved automatically.",
    "diagrams": "Show your stored data values as a diagram for a custom period of time. For this you need a previously defined filter (see above).",
    "question": "How to",
    "friends": "Share your device with other VBus.net users, in order to grant them access to your system. Thus, the users you share your device with can create their own diagrams and live systems, etc.",
    "monitoringGeneral": "With VBus.net monitoring you will have access to the error protocol in which errors will be listed automatically. You will also have access to the notifications by means of which you can monitor different system parameters and be informed via e-mail.",
    "monitoringNotification": "With the notifications you can select and monitor different system parameters. You can determine thresholds and compare them to the live data of your system by means of different criteria. If the conditions of a notification are fulfilled, you will be informed via e-mail. In the case of a connection breakdown, you will automatically receive an e-mail notification. Of course, you will also be informed if the connection has been re-established.",
    "monitoringErrorlog": "The error protocol gives an overview of errors that have occurred in your system. The protocol provides information on date and time of errors and, if supported by the controller, indicates the corresonding module and sensor. This can be used, for example, for troubleshooting. ",
    "reports": "Receive your system data regularly and automatically via e-mail. You can define a period of time and limit the number of data points with a previously defined filter (see above). You can also add further recipients of the scheduled downloads.",
    "backup": "Create a backup of all your visualization settings.",
    "extendedReports": "Receive information on the status of your solar system regularly via e-mail. You can receive information on the yield (as a diagram) or error messages, etc. for example once a week.",
    "conversionsAndArithmeticOperations": "Conversions and calculations of data points",
    "parametrization": "Parameterize your controller with your browser. Save configurations directly in VBus.net andtransfer them to your controller as needed."
  },
  "links": {
    "didNotReceiveConfirmationInstructions": "Didn't receive registration confirmation?",
    "didNotReceiveUnlockInstructions": "Didn't receive unlock instructions?"
  },
  "customer": {
    "examples": "Customer examples"
  },
  "dashboard": {
    "proSubscriptionSchemeEditor": "Advanced system editor",
    "testProSubscription": "Test VBus.net PRO for 30 days free of charge!",
    "proSubscriptionLiveData": "Data refresh every minute",
    "proSubscriptionWeatherDashboard": "Weather information for your location on the Dashboard",
    "proSubscriptionErrorLog": "Protocol of system errors",
    "proSubscriptionReporting": "Individually configurable notifications via e-mail",
    "proSubscriptionFriendship": "Sharing access rights, for example with your installer for information and service purposes",
    "proSubscriptionEnable": "Yes, I would like to test the PRO access",
    "proSubscriptionDoNotRemember": "No, do not remind me",
    "textClaimDemoQuestion": "You do not yet own a Datalogger or Communication module?",
    "textClaimDemo1": "Nevertheless, you wish to learn more about the possibilities of VBus.net?",
    "textClaimDemo2": "Then add a demo datalogger to your account.",
    "claimDemo": "Add demo datalogger now",
    "textClaimOwnQuestion": "You already own a Datalogger or a Communication module?",
    "textClaimOwn1": "Then add your own device to your account.",
    "claimOwn": "Add your device now",
    "noDiagramAvailable": "You have to create at least one diagram in order to display one on the dashboard.",
    "noLiveSystemAvailable": "You have to create at least one live system in order to display one on the dashboard.",
    "noWeatherAvailable": "You have to enter at least one location for your device in order to display one on the dashboard.",
    "demoVisualisierung": "Demo visualization",
    "ownVisualisierung": "Visualize your device",
    "chooseComponent": "Select a dashboard component",
    "addComponent": "Add new component",
    "editComponent": "Edit component",
    "changeBackgroundColor": "Change background color",
    "deleteAllComponents": "Delete all components",
    "addComponentInfo": "Add new components to your dashboard",
    "notAvailableInFullscreen": "Not available in full screen mode!",
    "reloadComponent": "Reload component",
    "deleteSelectedComponents": "Delete selected components",
    "deselectAll": "Unselect all",
    "noImageAvailable": "You have to create at least one image first, to show it on the dashboard.",
    "notAllowedForSubscription": "These contents are not or no longer available for your access!",
    "removeThisComponent": "Do you want to remove this component from the dashboard?",
    "removeSelectedComponents": "Do you want to remove the selected components from the dashboard?",
    "load": "Load dashboard",
    "loadFromOtherDevice": "Load dashboard from other device",
    "loadFromOtherDeviceInfo": "You can load and edit the dashboard settings from another device. The changes have no effect on the dashboard of the other device.",
    "settings": "Dashboard settings",
    "itemBorderTyp": "Border type",
    "itemBorderNone": "None",
    "itemBorder": "Border",
    "itemBorderShadow": "Shadow",
    "lockItems": "Lock components",
    "deleteQuestion": "Delete dashboard?",
    "delete": "delete dashboard"
  },
  "images": {
    "clickOnImageText": "Just click on the image you want to select.",
    "currentImage": "Current image"
  },
  "enter": {
    "name": {
      "diagram": "Please enter a diagram name",
      "filter": "Please enter a filter name",
      "scheme": "Please enter a system name",
      "image": "Please enter an image name"
    },
    "vbus": {
      "password": "Please enter the VBus password and click on CONTINUE…"
    }
  },
  "prepare": {
    "download": "Preparing your data. This may take a while. Please wait..."
  },
  "access": {
    "denied": "Access denied"
  },
  "data": {
    "filter": "Filters",
    "transmission": {
      "running": "Data transfer in progress…"
    }
  },
  "genral": {
    "to": "To"
  },
  "unselect": {
    "all": "Unselect all"
  },
  "my": {
    "account": "My account",
    "diagrams": "My diagrams",
    "downloads": "My downloads",
    "schemes": "My live data",
    "devices": "My Devices",
    "friends": "Users with access to my devices",
    "reports": "My reports"
  },
  "limitationText": {
    "noConfiguration": "No Datalogger configuration possible",
    "only90days": "Only 90 days of data stored available",
    "onlyDemoDatalogger": "Access to Demo Datalogger only"
  },
  "info": {
    "smallerLogInterval": "Smaller log intervals adjusted in your Datalogger are not supported by VBus.net.",
    "logInterval": "VBus.net stores the data recorded by your RESOL Datalogger in steps of at least 5 minutes.",
    "clickToDelete": "Delete: <i class=\"fa fa-trash-o clickToDelete\"></i>",
    "clickToEdit": "Edit: <i class=\"fa fa-edit clickToEdit\"></i>",
    "clickToMove": "Move: <i class=\"fa fa-arrows-v clickToEdit\"></i>"
  },
  "modal": {
    "info": {
      "filter": "If you want to get a selection of custom data values create a <a class='link' href='/vbus/add-selector'>filter</a> for your system first. Then you can choose between your custom filters."
    }
  },
  "discover": {
    "deviceDiscovery": "Device Discovery",
    "deviceDiscoveryWizard": "Device Discovery Wizard"
  },
  "unlocks": {
    "resendUnlockInstructions": "Please send unlock instructions again"
  },
  "activerecord": {
    "errors": {
      "models": {
        "ownership": {
          "attributes": {
            "name": {
              "too_short": " is too short (minimum is 3 characters)"
            }
          }
        }
      }
    }
  },
  "forward": {
    "toWebinterfaceOfDatalogger": "Forwarding to the Web interface of the Datalogger...",
    "notAllowedToAccessOwnership": "You are not allowed to access this device.",
    "textForwardedToWebInterface": "If this was your device, you would be forwarded to its internal Web interface in just a few moments. For the demonstration Datalogger, this feature is not available. Sorry for the inconvenience.",
    "textLoginOtherCredentials": "Please remember that the login credentials on the internal web interface of your device will differ from the ones you use for your VBus.net account.",
    "textYouWillBeForwarded": "You will be forwarded to the web interface of your device in just a few moments. If you are not forwarded automatically, please click the following link.",
    "datenloggerLink": "Device interface"
  },
  "paypal": {
    "buy": {
      "now": "Buy Now"
    },
    "order": {
      "text": "Please note that your order may take a few day to process.",
      "error": "An error has occured during data transmission to or from Paypal. Please contact our technical support if the feature bought has not been activated."
    }
  },
  "invalid": {
    "via_tag": "The Via tag must have at least 3 characters, starting with a lower-case letter. It may contain lower-case letters, numbers, hyphens and underscores."
  },
  "incorrect": {
    "failure": {
      "already_activated": "This via tag is already in use. Please choose another."
    }
  },
  "selected": {
    "dataFields": "Selected data fields"
  },
  "legend": {
    "description": "Legend",
    "layout": {
      "align": "Layout",
      "horizontal": "Horizontal",
      "vertical": "Vertical"
    },
    "position": {
      "horizontal": "Horizontal position",
      "vertical": "Vertical position",
      "left": "Left",
      "central": "Center",
      "right": "Right",
      "top": "Top",
      "bottom": "Bottom"
    }
  },
  "datapoint": {
    "selectedOne": "selected data point",
    "selectedMore": "selected data points"
  },
  "information": {
    "minOneOwnership": "In order to use the visualization functions, you need to add at least one device or demo Datalogger to your account."
  },
  "tip": {
    "location": "If you submit a location for your device, you will be able to access weather data in your Dashboard. Just enter the coordinates of your system or search for your location."
  },
  "messages": {
    "tryGeodata": "Enter your coordinates directly."
  },
  "get": {
    "professional": {
      "account": "Get your PRO access now..."
    }
  },
  "one": {
    "year": {
      "vbus": {
        "professional": "1 year VBus.net PRO"
      }
    }
  },
  "register": {
    "subscribe": {
      "newsletter": "I want to subscribe to the RESOL newsletter."
    },
    "free": "Sign up now for free"
  },
  "homepage": {
    "greetingText": "The Internet portal for easy and secure access to your system data",
    "simpleText": "Easy access in only two steps",
    "registerText": "<a href=\"#register\">Sign up</a> for free on VBus.net ",
    "addDataloggerText": "Add your device to VBus.net",
    "initationText": "VBus.net is all about the data of your RESOL controller. Live data of your system, customized filter settings and much more await you.",
    "dataViewerHeader": "Integrated in VBus.net - the VBus Data Viewer",
    "dataViewerInfo": "Visualize data stored on an SD card in the VBus Data Viewer"
  },
  "errorLog": {
    "thankYou": "Thank your for sending us your error report.",
    "ticketNumberText": "Your ticket now has the following number:"
  },
  "rerrorReport": {
    "helpText": "Help us improve VBus.net by letting us know about malfunctions which might have occured."
  },
  "friendshipToken": {
    "typeOfUse": "Use",
    "useText": "Please enter a name for identifiying the access token afterwards. Thus you will have an overview of the persons you shared your device with."
  },
  "cookies": {
    "name": "Cookies",
    "useVBusnet": "You have to accept cookies in order to be able to use VBus.net.",
    "description1": "Cookies are small text files that will be transferred from a website and stored on your computer. A cookie stores information on your last visit of a website such as your language preferred and other settings.",
    "description2": "VBus.net uses cookies only to store your language setting and log-in information.",
    "furtherInformation": "Further information on cookies and their administration can be found on ",
    "disclaimerExternalLinks": "Please note that we are not responsible for the contents of external websites. ",
    "privacyPolicy": "More information about cookies and their use can be found in our"
  },
  "subscribe": {
    "maintenance": "Yes, I would like to be informed on maintenance work by e-mail."
  },
  "title": {
    "help": "Help"
  },
  "original": {
    "names": "Default name",
    "value": "Original value"
  },
  "cookie": {
    "acceptText": "Cookie guidelines"
  },
  "viaTag": {
    "useDefaultPassword": "Your device can be accessed with the standard password!",
    "ChangePasswordText": "For safety purposes please change the password of your device."
  },
  "lineChart": {
    "diagram": "Line diagram (absolute)"
  },
  "barChart": {
    "diagram": "Bar diagram (daily summary)"
  },
  "werbung": {
    "textDatenlogger": "More information about our Dataloggers / Communication modules?",
    "textKommunikationsmodul": "Have you discovered our Communication module, yet?",
    "textSolarregler": "Have you met our DeltaSol® solar and system controllers?",
    "textHeizungsregler": "Would you like to learn more about our family of heating controllers?"
  },
  "notice": {
    "dataloggerTimeout": "This device has not been delivering live data for several minutes…",
    "dataloggerInitialze": "Initialization",
    "dataloggerInitialzeText": "It may take a few minutes for your device to initialize…",
    "dataloggerInitialzed": "Your device has completed initialization. You can start visualization now."
  },
  "nextStep": {
    "step2": "In order to create a <b>Live System</b>, you will need an __IMAGE__.",
    "step3": "Now you can create a __DIAGRAM__ or a __LIVESYSTEM__.",
    "step4": "Create a __DOWNLOAD__ of your data in order to manually treat or analyze them.",
    "step1": "Create a __FILTER__ first in order to create a <b>Diagramm</b> or a <b>Live system</b>.<br/>A <b>Download</b> can also be optimized by means of a filter."
  },
  "support": {
    "noDatafromDevice": "No data could be received from your device!",
    "pleaseCheck": "Please have a look at the manual of the device and check the following:",
    "checkPowerSupply": "Power supply of the router and the Datalogger / Communication module",
    "checkInternetConnection": "Internet connection",
    "checkConncectionToDevice": "Connection from the router to the Datalogger / Communication module ",
    "checkManual": "More information can be found in the manual of your device. ",
    "hintIntranet": "For company networks: The ports 1194 and 1195 are blocked by your firewall. Please contact your system administrator.",
    "allowAccessToAccount": "Allow access to your VBus.net account",
    "token": "Support token",
    "needHelp": "You need help and want to give our support team permission to access your VBus.net account? Create a support token here and call our support team by phone.",
    "tokenRemove": "Delete support token",
    "tokenCreate": "Create support token",
    "extended": "Extended support"
  },
  "areaChart": {
    "diagram": "Area chart"
  },
  "userFeedback": {
    "helpUs": "Help us improve VBus.net<br /> and get a free month PRO!",
    "takeTheSurvey": "Take the survey",
    "question1": "How do you rate the registration process of VBus.net?",
    "question2": "How do you evaluate the explanations of the functions and the support videos?",
    "question3": "How do you rate the general functionality of VBus.net?",
    "question4": "How do you evaluate the user friendliness?",
    "question5": "How do you rate the visualizations regarding practice and design?",
    "question6": "How useful and beneficial is VBus.net for you?",
    "question7": "Are you planning to extend your PRO licence?",
    "question8": "What are the reasons against the PRO licence?",
    "question9": "How often do you use / will you use VBus.net?",
    "question10": "What features / improvements do you want for VBus.net?",
    "question11": "What problems have you encountered with VBus.net?",
    "question12": "How likely is it that you recommend VBus.net?",
    "question13": "Other experiences/general comments?",
    "submit": "Submit feedback",
    "simple": "Simple",
    "complicated": "Complicated",
    "veryHelpful": "Very helpful",
    "redundant": "Redundant",
    "notUsed": "Not used",
    "excellent": "Excellent",
    "insufficient": "Insufficient",
    "veryEasy": "Very easy",
    "extremelyComplex": "Extremely complex",
    "veryGood": "Very good",
    "veryBad": "Very bad",
    "indispensable": "Indispensable",
    "useless": "Useless",
    "dontKnowYet": "Don´t know yet",
    "price": "Price",
    "noAdditionalValue": "No additional value",
    "other": "Other",
    "daily": "Daily",
    "weekly": "1 - 3x a week",
    "monthly": "1 - 3x a month",
    "lessThanMonth": "less than once a month",
    "quietSure": "Quiet sure",
    "certainlyNot": "Certainly not",
    "backToDashboard": "Back to the Dashboard",
    "answerAllQuestions": "Please answer all questions marked with <i class = \"fa fa-times\" aria-hidden = \"true\"> </ i>",
    "extendedPro": "Your PRO access has been extended by 30 days."
  },
  "dashboardMessage": {
    "changeViaTag": "For technical reasons, the via tag extension has changed from <kbd>.via.vbus.net</kbd> to <kbd>.vbus.io.</kbd> Please adapt your bookmarks, if necessary.<br><br>(Example: mydl2.via.vbus.net -> mydl2.vbus.io). Further adjustments are not required."
  },
  "config": {
    "startWithout": "Start without configuration",
    "empty": "empty",
    "notLoadable": "not loadable"
  },
  "check": {
    "completed": "Check completed…"
  },
  "waiting": {
    "running": {
      "tasks": "Running tasks are being finished…"
    }
  },
  "dsgvo": {
    "Nutzungsbedingungen": "I have read and understood the <a href=\"#register\" class=\"open-terms-of-use\">Terms of use</a> and I accept them.",
    "Datenschutzerklaerung": "I have read and understood the <a href=\"#register\" class=\"open-privacy-policy\">Privacy Policy</a> and I accept it."
  },
  "pro": {
    "validUntil": "PRO access valid until"
  },
  "channel": {
    "no": "Channel no."
  },
  "location": {
    "notFound": "No location found!"
  },
  "faq": {
    "q1": "How do I add a device to VBus.net?",
    "a1": "Log in to VBus.net. Open the menu My Devices and click on Add new device. Enter the access code/token of your device.",
    "q2": "How do I create a support report?",
    "a2_1": "Log into the KM2 web interface. Configuration -> General -> enable Expert mode. Status -> Support report click on Download.",
    "a2_2": "Save the file and send it to __EMAIL__.",
    "a2_3": "Enter the IP address of the Datalogger in the browser and log in to the web interface.",
    "a2_4": "Enter the URL http://[IP OF THE DEVICE]/dlx/support",
    "a2_5": "The link \"Click here to generate and download the support report\" appears, by means of which the download can be carried out.",
    "q3": "My device is offline, what can I do?",
    "a3": "Check, whether your device is connected to the Internet. If other devices in the same network are not connected to the Internet, there might be a problem with the Internet connection. In order to enable VBus.net access, the device must have unconditional access to the ports 80 and 1194 / 1195. Access to the ports must not be blocked by a firewall.",
    "q4": "Do I have to pay for VBus.net?",
    "a4": "The basic version of VBus.net is free of charge. You can visualize your system and receive live data every 5 minutes. The PRO version costs 39 € per year and offers, besides the basic functions, many possibilities for monitoring and enhanced visualisation functions. Furthermore, parameterization via WebRPT is possible and your live data are refreshed every minute. ",
    "q5": "What is the difference between VBus.net Basic and PRO?",
    "a5": "Here you will find a comparison between the different VBus.net versions: __VERSIONSVERGLEICH__",
    "q6": "Does VBus.net support the VBus®/LAN interface adapter?",
    "a6": "No, in order to connect your controller with VBus.net, a KM2 communication module, DL2 Datalogger or DL3 Datalogger is required.",
    "q7": "My diagrams are not shown correctly, what can I do? ",
    "a7": "Please check, whether the time zone under My Devices is correctly adjusted and whether it corresponds to the location of the device. Check the time zone on the device.",
    "q8": "What is the parameterization password?",
    "a8": "vbus",
    "title": "Answers to your most frequently asked questions",
    "hints": "Please make sure you use a current browser version. Should problems still occur, please use a different browser.",
    "notFound": "Your question has not been ansered? Please contact us under __LINK__.",
    "q9": "In a diagram, unused labels are on the Y axis.",
    "a9": "The filter used in this diagram must be saved again.",
    "q10": "Not all values are displayed in my live system, chart, or download.",
    "a10": "Check the corresponding filter and save it again, if necessary.",
    "q11": "Why is VBus.net no longer working on my older Android device v2.x or Smart TV?",
    "a11": "VBus.net has adjusted its security settings to the current standard. Therefore older devices can no longer call VBus.net. Update your device to use VBus.net again. Check with your device manufacturer if there is new software for your device."
  },
  "createImageFirst": "You must create an image first...",
  "professinal": {
    "expiredOn": "Pro access expired on __VALID_UNTIL__!",
    "expireInfo": "Please note that after expiration of the PRO access services like scheduled downloads, reports, and notifications will no longer be available! Your account will then be automatically continued in the free basic version."
  },
  "validation": {
    "positiveNumber": "positive number"
  },
  "reset": {
    "allEntries": "Reset all entries"
  },
  "fileSizeToBig": "The file is too big!",
  "controllerVersionChanged": "The version of your controller has changed!",
  "cantLoadConfigurations": "Some configurations may not load because they are not supported by this release.",
  "dl3NotSupported": "DL3 is currently not supported!",
  "change": {
    "modulename": "Change module names"
  },
  "email": {
    "doNotReply": "This is an automatically sent e-mail. Please do not reply to this message as the e-mail address is not set up to receive emails."
  },
  "discoveryTool": {
    "title": "Device-Discovery-Tool",
    "text": "The Device Discovery Tool searches for RESOL devices on the local network and provides diagnostics for connection issues with VBus.net."
  },
  "group": {
    "create": "Create group",
    "edit": "Edit group",
    "delete": "Delete group",
    "deleteGroup": "Do you want to delete the group?",
    "neDeviceDelete": "The devices in the group are not deleted."
  },
  "filterValue": {
    "add": "Add filter value",
    "sub": "Subtract filter value",
    "mul": "Multiply filter value",
    "div": "Divide filter value",
    "conversionWithFilter": "Conversion with filter value",
    "linkedTo": "Used by"
  },
  "errorSendingEmails": "Several times we were unable to deliver any emails to one or more recipients in the services (Scheduled Downloads, Reports or Notifications)!",
  "errorSendingEmailConfirm": "Are you sure? You have to confirm the e-mail address for each service individually!",
  "confirmEmailServices": "Confirm my e-mail address in the services (Scheduled Downloads, Reports or Notifications) again.",
  "keyboard": {
    "capsLockActive": "Caps lock active!"
  },
  "firmware": {
    "title": "RESOL Device Firmware Update",
    "available": "The following firmware is available for your device",
    "downloadText": "If you like to download the firmware including its associated source code you can do so using the following link:",
    "deviceInstall": "Your device will install the update automatically.",
    "acceptText": "I have taken note of the information and would like to activate the automatic update for this firmware.",
    "alreadyAccepted": "You have already activated the automatic update for this firmware.",
    "activateAutomaticUpdate": "activate automatic update"
  },
  "onboardingAssistant": "VBus.net setup assistant",
  "onboardingAssistantInfo": "The setup assistant supports you in setting up your device and configuring your system in VBus.net.",
  "onboardingAssistantText": "In just a few steps, you can set up your device and create a visualization that includes filters, a background image and a live system and is optimally tailored to your system. If you don't have a device yet, you can add a demo device to your account and try out VBus.net.",
  "onboardingAssistantStart": "Start setup assistant",
  "onboarding": "Setup",
  "supportedDevicesText": "Templates are available for the following devices:",
  "helpVideos": "Help videos",
  "demoSLLText": "This demo system simulates a DL2 Plus datalogger to which the DeltaSol<sup>®</sup> SLL solar controller is connected.",
  "demoPVMaxText": "This demo system simulates a DeltaTherm<sup>®</sup> PV MAX, which is directly connected to VBus.net via the built-in interface.",
  "addThisDemoSystem": "Add this demo system",
  "forwardingActive": "Forwarding active",
  "forwardingInactive": "Forwarding inactive"
}



// WEBPACK FOOTER //
// ./src/locales/en/index.js